exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".DefineRemoveInterventionTimelimitFromInterventionPeriodForm-interventionTimelimitGroup-1dl3T{margin:10px 0;padding:0;list-style-type:none}.DefineRemoveInterventionTimelimitFromInterventionPeriodForm-interventionTimelimitGroup-1dl3T>li{overflow:hidden;display:block;padding:10px;border-bottom:1px solid #dadada}.DefineRemoveInterventionTimelimitFromInterventionPeriodForm-interventionTimelimitGroup-1dl3T>li .DefineRemoveInterventionTimelimitFromInterventionPeriodForm-remove-1U6Tt{display:block;float:right}.DefineRemoveInterventionTimelimitFromInterventionPeriodForm-interventionTimelimitGroup-1dl3T>li p{overflow:hidden;margin:0;font-size:14px;font-weight:400;color:#546d79}", ""]);

// exports
exports.locals = {
	"interventionTimelimitGroup": "DefineRemoveInterventionTimelimitFromInterventionPeriodForm-interventionTimelimitGroup-1dl3T",
	"remove": "DefineRemoveInterventionTimelimitFromInterventionPeriodForm-remove-1U6Tt"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/provider/components/DefineRemoveInterventionTimelimitFromInterventionPeriodForm.less
// module id = 1713
// module chunks = 0